export const partnerLogos = [
  {
    name: "Hertz",
    className:
      "italic underline decoration-[#f5d000] decoration-[3px] underline-offset-[3px]",
  },
  {
    name: "Expedia",
    className:
      "before:mr-1 before:inline-block before:h-4 before:w-4 before:rounded-sm before:bg-[#f4d000] before:content-['']",
  },
  {
    name: "KAYAK",
    className: "bg-orange-600 px-2 py-1 text-white tracking-[0.18em]",
  },
  { name: "AVIS", className: "text-rose-600 tracking-[0.06em]" },
  {
    name: "Budget",
    className:
      "before:mr-1 before:inline-block before:h-3 before:w-5 before:bg-[linear-gradient(135deg,#ff6d2d_0_50%,transparent_50%)] before:content-['']",
  },
  {
    name: "enterprise",
    className:
      "bg-[linear-gradient(90deg,#009a44_0_28%,#1b1b1b_28%_100%)] px-2 py-1 text-sm lowercase text-white",
  },
  {
    name: "Alamo",
    className:
      "border-2 border-blue-700 bg-yellow-300 px-2 py-1 text-xs text-blue-700",
  },
  { name: "SIXT", className: "italic tracking-[0.08em] text-blue-700" },
];
